import React, { useState } from "react";
import Pricingsectionparticular from "./Pricingsectionparticular";

function Promotionspricingdetails({ feature, onBack }) {

    const [showBackButton, setShowBackButton] = useState(true);
    const [showTabs, setShowTabs] = useState(true);        // 👈 NEW
    const [pricingMode, setPricingMode] = useState("fixed");

    return (
        <div
            style={{
                padding: "20px",
                borderRadius: "12px",
            }}
        >
            {(showBackButton || showTabs) && (              // 👈 hide whole row if both are hidden
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "15px",
                        flexWrap: "wrap",
                        gap: "10px",
                    }}
                >
                    {showBackButton ? (
                        <button
                            onClick={onBack}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "7px 14px",
                                background: "#ff7a00",
                                color: "#fff",
                                border: "none",
                                borderRadius: "20px",
                                fontSize: "13px",
                                fontWeight: "600",
                                cursor: "pointer",
                            }}
                        >
                            ← Back
                        </button>
                    ) : (
                        <span />
                    )}

                    {showTabs && (                            // 👈 NEW: only render tabs if visible
                        <div
                            style={{
                                display: "flex",
                                gap: "6px",
                                background: "#f3f4f6",
                                padding: "4px",
                                borderRadius: "24px",
                            }}
                        >
                            <button
                                onClick={() => setPricingMode("fixed")}
                                style={{
                                    padding: "7px 18px",
                                    borderRadius: "20px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    background: pricingMode === "fixed" ? "#e66d33" : "transparent",
                                    color: pricingMode === "fixed" ? "#fff" : "#374151",
                                    transition: "all 0.2s ease",
                                }}
                            >
                                Fixed
                            </button>

                            <button
                                onClick={() => setPricingMode("custom")}
                                style={{
                                    padding: "7px 18px",
                                    borderRadius: "20px",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    background: pricingMode === "custom" ? "#e66d33" : "transparent",
                                    color: pricingMode === "custom" ? "#fff" : "#374151",
                                    transition: "all 0.2s ease",
                                }}
                            >
                                Custom
                            </button>
                        </div>
                    )}
                </div>
            )}

            <Pricingsectionparticular
                feature={feature}
                pricingMode={pricingMode}
                hideParentBack={() => setShowBackButton(false)}
                showParentBack={() => setShowBackButton(true)}
                hideParentTabs={() => setShowTabs(false)}     // 👈 NEW
                showParentTabs={() => setShowTabs(true)}      // 👈 NEW
            />
        </div>
    );
}

export default Promotionspricingdetails;